export default "__VITE_ASSET__CuDcyX6h__"